(function () {
  document.querySelectorAll('[data-screen-label="How to Administer"]').forEach(function (section) {
    var tabs = section.querySelectorAll('[data-pdp-admin-tab]');
    var panels = section.querySelectorAll('[data-pdp-admin-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-pdp-admin-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-pdp-admin-panel') === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
          if (!active) {
            panel.querySelectorAll('details[open]').forEach(function (d) {
              d.open = false;
            });
          }
        });
      });
    });

    section.querySelectorAll('.pdp-admin-step').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var panel = details.closest('[data-pdp-admin-panel]');
        if (!panel) return;
        panel.querySelectorAll('.pdp-admin-step').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });
  });
})();
